import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('detailsViewCloseButton');

    return {
        ESC: t('esc')
    };
};

export default useTranslation;
